import React, { useEffect, useState, memo } from 'react'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import moment from 'moment'
import uuidV4 from 'uuid/v4'
import RenderBoardForm from '../../../../componentIsoMophic/ScrumBoard/RenderBoardForm/RenderBoardForm'
import { dateFormat } from '../../../../componentIsoMophic/ScrumBoard/FieldFormats'
import { IconSvg } from '../../../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'
import scrumBoardActions from '../../../../redux/scrumBoard/actions'
import mediaAction from '../../../../redux/qbmedia/actions'
import orgAction from '../../../../redux/organization/actions'
import ArrowIcon from '../../../assets/images/icon/04-icon.svg'
import CloseIcon from '../../../assets/images/icon/07-icon.svg'
import {
    Form,
    Input,
    Switch,
    Upload,
    Select,
    DatePicker,
    Icon,
    Row,
} from 'antd'
import { Spin } from 'antd'
import { FaCheck, FaTimes, FaPlus, FaTasks } from 'react-icons/fa'
import { compose } from 'redux'
import Button from '../../../../components/uielements/button'
import CustomInput from '../../../../componentsMaterial/CustomInput/CustomInput.jsx'
import Modal from '../../../../components/feedback/modal'
import MediaManagementScreen from '../../../MediaManagement/index'
import { baseUrlPhotoCloud } from '../../../../services/apis/createAPIServices'

import {
    Wrapper,
    FormWrapper,
    Heading,
    TopBar,
} from './BoardCreateOrUpdate.style'
const { Option } = Select
const { TextArea } = Input

let initialValues = {
    id: '',
    column_orders: [],
    title: '',
    category: '',
    progress: '',
    thumb: '',
    open_to_company: false,
    open_to_members: true,
    editing: false,
    created_at: moment(Date.now(dateFormat)).toString(),
    updated_at: moment(Date.now(dateFormat)),
    selectOptions: ['Software', 'OPs', 'Service Desk', 'Business', 'General'],
    selectAssignees: ['Mark', 'Bob', 'Anthony'],
}
function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
}

const CreateOrUpdateBoard = props => {
    const [imageUrl, setimageUrl] = useState(null)
    const [loading, setloading] = useState(false)
    useEffect(() => {
        props.loadListOrganization(0)
        if (props.location.state) {
            props.getListMediaQueryById(props.location.state.data.lst_media)
        } else {
            props.getListMediaQueryByIdDone([])
        }
    }, [])

    const initials = {
        ...initialValues,
        ...props.board,
        updated_at: moment(Date.now(dateFormat)).toString(),
        selectOptions: props.listOrg,
    }

    const handleSubmit = values => {
        if (!values.editing) {
            values.id = uuidV4()
        }
        console.log('value create task', props.listOrg)
        props.createOrUpdateBoardWatcher(values)
        props.history.push(`/app/qbtask/project/${values.id}`)
    }
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
    }
    const formItemLayoutWithOutLabel = {
        wrapperCol: {
            xs: { span: 24, offset: 24 },
            sm: { span: 16, offset: 8 },
        },
    }

    const handleOK = () => {
        props.showModalMedia(false)
    }

    const handleCancel = () => {
        props.showModalMedia(false)
    }

    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setloading(true)
            setimageUrl(null)
            return
        }
        if (info.file.status === 'done') {
            // this.props.updateAvatar(info.file.originFileObj)
            console.log('info img', info)
            let formData = new FormData()
            formData.append(
                'files',
                info.file.originFileObj,
                info.file.originFileObj.name
            )
            fetch(baseUrlPhotoCloud, {
                method: 'POST',

                body: formData,
            })
                .then(respone => respone.json())
                .then(data => {
                    setloading(false)
                    setimageUrl(data.uploaded_files[0])
                    console.log('data img respone', data)
                })
                .catch(error => console.log('error imgupload', error))
        }
    }

    return (
        <Wrapper>
            <FormWrapper>
                {/* <Formik
                    initialValues={initials}
                    onSubmit={handleSubmit}
                    render={RenderBoardForm}
                /> */}
                <Form
                    {...formItemLayout}
                    onSubmit={evt => {
                        evt.preventDefault()
                        // props.onSubmitForm(props.form)
                        props.form.validateFieldsAndScroll((err, values) => {
                            if (!err) {
                                console.log(
                                    'value submit form',
                                    props.location.state
                                )
                                if (props.location.state && !loading) {
                                    console.log('do up date')
                                    const lstMediaID = []
                                    props.ListCurrentMedia.map(media => {
                                        lstMediaID.push(media.media_id)
                                    })
                                    const body = {
                                        avatar: imageUrl
                                            ? imageUrl
                                            : props.location.state.data.avatar,
                                        deadline: values.deadline
                                            ? (values.deadline._d.valueOf() /
                                                  1000) >>
                                              0
                                            : props.location.state.data
                                                  .deadline,
                                        lst_event_id:
                                            props.location.state.data
                                                .lst_event_id,
                                        lst_hashtag:
                                            props.location.state.data
                                                .lst_hashtag,
                                        lst_object_id:
                                            props.location.state.data
                                                .lst_object_id,
                                        lst_organ_receive_id:
                                            props.location.state.data
                                                .lst_organ_receive_id,
                                        lst_uid_receive:
                                            props.location.state.data
                                                .lst_uid_receive,
                                        lst_media: lstMediaID,
                                        name: values.name,
                                        note: values.note,
                                    }
                                    props.updateTask(
                                        body,
                                        props.location.state.data.id,
                                        props.history
                                    )
                                } else {
                                    const lstMediaID = []
                                    props.ListCurrentMedia.map(media => {
                                        lstMediaID.push(media.media_id)
                                    })
                                    const bodycreate = {
                                        avatar: imageUrl ? imageUrl : '',
                                        deadline:
                                            (values.deadline._d.valueOf() /
                                                1000) >>
                                            0,
                                        lstReportID: [],
                                        lst_event_id: [],
                                        lst_hashtag: [],
                                        lst_object_id: [],
                                        lst_organ_receive_id: [],
                                        lst_uid_receive: [],
                                        lst_media: lstMediaID,
                                        name: values.name,
                                        note: values.note,
                                    }
                                    props.createNewTask(
                                        bodycreate,
                                        props.history
                                    )
                                }
                            }
                        })
                    }}
                >
                    <Form.Item
                        label={null}
                        extra={null}
                        style={{ marginLeft: '40%' }}
                    >
                        {props.form.getFieldDecorator('upload', {})(
                            <Upload
                                name="avatar"
                                showUploadList={false}
                                listType="picture-card"
                                className="avatar-uploader"
                                onChange={handleChange}
                                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                style={{ backgroundColor: 'white' }}
                            >
                                {props.location.state &&
                                props.location.state.data.avatar !== '' ? (
                                    <img
                                        src={props.location.state.data.avatar}
                                        alt="avatar"
                                        style={{ width: '100%' }}
                                    />
                                ) : imageUrl && imageUrl !== '' ? (
                                    <img
                                        src={imageUrl}
                                        alt="avatar"
                                        style={{ width: '100%' }}
                                    />
                                ) : (
                                    <div>
                                        {loading ? <Spin /> : <FaPlus />}
                                        <div
                                            className="ant-upload-text"
                                            style={{ fontSize: 13 }}
                                        >
                                            Ảnh nhiệm vụ
                                        </div>
                                    </div>
                                )}
                            </Upload>
                        )}
                    </Form.Item>
                    <Form.Item label="Tên nhiệm vụ" hasFeedback>
                        {props.form.getFieldDecorator('name', {
                            initialValue: props.location.state
                                ? props.location.state.data.title
                                : '',
                            rules: [
                                {
                                    required: true,
                                    message: 'Xin mời nhập tên nhiệm vụ',
                                },
                            ],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="Nội dung nhiệm vụ" hasFeedback>
                        {props.form.getFieldDecorator('note', {
                            initialValue: props.location.state
                                ? props.location.state.data.content
                                : '',
                            rules: [
                                {
                                    required: true,
                                    message: 'Xin mời nhập nội dung nhiệm vụ',
                                },
                            ],
                        })(<TextArea rows={10} />)}
                    </Form.Item>
                    <Form.Item label="Thời gian kết thúc" hasFeedback>
                        {props.form.getFieldDecorator('deadline', {
                            initialValue:
                                props.location.state &&
                                props.location.state.data.deadline > 0
                                    ? moment(
                                          moment(
                                              props.location.state.data
                                                  .deadline * 1000
                                          ).format('DD/MM/YYYY'),
                                          'DD-MM-YYYY'
                                      )
                                    : '',

                            rules: [
                                {
                                    required: true,
                                    message:
                                        'Hãy chọn thời gian kết thúc của nhiệm vụ này',
                                },
                            ],
                        })(
                            <DatePicker
                                format={`DD-MM-YYYY`}
                                onChange={value => {}}
                                style={{ width: 300 }}
                                placeholder="Thời gian kết thúc nhiệm vụ"
                            />
                        )}
                    </Form.Item>
                    <Form.Item label="Tài liệu nhiệm vụ">
                        {props.ListCurrentMedia.map(media => (
                            <Button
                                type="link"
                                href={media.url}
                                block={false}
                                style={{ paddingLeft: 5 }}
                            >
                                {media.name}
                            </Button>
                        ))}
                        <Button
                            type="primary"
                            icon="upload"
                            onClick={() => props.showModalMedia(true)}
                            style={{ marginLeft: 20 }}
                        >
                            Chọn tài liệu
                        </Button>
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{ span: 24 }}
                        style={{ textAlign: 'right', marginTop: 10 }}
                    >
                        <Button
                            size="large"
                            htmlType="submit"
                            style={{
                                backgroundColor: '#0178c0',
                                marginRight: 5,
                                color: 'white',
                            }}
                        >
                            {props.location.state
                                ? 'Sửa thông tin nhiệm vụ'
                                : 'Tạo mới nhiệm vụ'}
                        </Button>
                    </Form.Item>
                </Form>
            </FormWrapper>
            <Modal
                visible={props.VisibleModalMedia}
                onOk={() => handleOK()}
                onCancel={() => handleCancel()}
                width={window.innerWidth / 2}
                centered={false}
                footer={[]}
            >
                <MediaManagementScreen isShowInTask={true} />
            </Modal>
        </Wrapper>
    )
}
const withConnect = connect(
    (state, ownProps) => ({
        board: state.scrumBoard.boards[ownProps.match.params.id],
        listOrg: state.organization.organizations,
        VisibleModalMedia: state.scrumBoard.VisibleModalMedia,
        ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
    }),
    {
        ...scrumBoardActions,
        ...orgAction.action,
        ...mediaAction.action,
    }
)
export default compose(
    withConnect,
    Form.create({}),
    memo
)(CreateOrUpdateBoard)
// export default connect(
//     (state, ownProps) => ({
//         board: state.scrumBoard.boards[ownProps.match.params.id],
//         listOrg: state.organization.organizations,
//     }),
//     {
//         ...scrumBoardActions,
//         ...orgAction.action,
//     }
// )(CreateOrUpdateBoard)
